import React from 'react';
import { PlanningView } from './components/PlanningView';

export const PlanningTab: React.FC = () => {
  return <PlanningView />;
};